export const SYSTEM_NAME = 'LIBTUKE';

export const PRODUCTION_BUILD = true;

export const PROD_BUILD_USE_HTTPS = true;

export const DEVAPI_BUILD = false;

export const DEV_BUILD_USE_HTTPS = false;
